import { initContract } from "@ts-rest/core";

import { addressesContract } from "./addressesContract";
import { authContract } from "./authContract";
import { clientsContract } from "./clientsContract";
import { companyContract } from "./companyContract";
import { companyMachinesContract } from "./companyMachinesContract";
import { contactsContract } from "./contactsContract";
import { layoutsContract } from "./layoutsContract";
import { materialsContract } from "./materialsContract";
import { partsContract } from "./partsContract";
import { quotesContract } from "./quotesContract";
import { usersContract } from "./usersContract";
export { quoteRequestsContract } from "./quoteRequestsContract";
export { quoteRequestsV2Contract } from "./quoteRequestsV2Contract";
export { quoteRequestLinesContract } from "./quoteRequestLinesContract";
export { searchContract, SearchEntity } from "./searchContract";
import { adminContract } from "./adminContract";
import { aiContract } from "./aiContract";
import { clusterContract } from "./clusterContract";
import { companySettingsContract } from "./companySettingsContract";
import { defaultProcessStepsContract } from "./defaultProcessStepsContract";
import { exportContract } from "./exportContract";
import { externalApiContract } from "./externalApiContract";
import { feedbackContract } from "./feedbackContract";
import { materialLayoutsContract } from "./materialLayoutsContract";
import { modelsContract } from "./modelsContract";
import { nestingContract } from "./nestingContract";
import { notificationsContract } from "./notificationsContract";
import { onboardingProcessStepsContract } from "./onboardingProcessStepsContract";
export { optimizationsContract } from "./optimizationsContract";
import { permissionsContract } from "./permissionsContract";
import { prefectContract } from "./prefectContract";
import { processStepsContract } from "./processStepsContract";
import { productLinesContract } from "./productLinesContract";
import { productsContract } from "./productsContract";
import { publicContract } from "./publicContract";

const c = initContract();

export const coreContract = c.router({
  auth: authContract,
  clients: clientsContract,
  addresses: addressesContract,
  company: companyContract,
  companySettings: companySettingsContract,
  contacts: contactsContract,
  users: usersContract,
  admin: adminContract,
  permissions: permissionsContract,
});

export const businessContract = c.router({
  ai: aiContract,
  cluster: clusterContract,
  companyMachines: companyMachinesContract,
  defaultProcessSteps: defaultProcessStepsContract,
  layouts: layoutsContract,
  materialLayouts: materialLayoutsContract,
  materials: materialsContract,
  parts: partsContract,
  products: productsContract,
  productLines: productLinesContract,
  public: publicContract,
  quotes: quotesContract,
  processSteps: processStepsContract,
  prefect: prefectContract,
  models: modelsContract,
  notifications: notificationsContract,
  onboardingProcessSteps: onboardingProcessStepsContract,
  feedback: feedbackContract,
  export: exportContract,
  nesting: nestingContract,
});

export const externalContract = c.router({
  external: externalApiContract,
});
